/* eslint-disable */
let self;
let datalayer;
let page_type;
let content_group;
let content_type;
let content_variant;
let get_datalayer;

export class DataLayer_data_ready {
  constructor( datalayer_attr ) { // Receive part of the attributes to create the datalayer
    self = this;
    page_type = datalayer_attr.page_type;
    content_group = datalayer_attr.content_group;
    content_type = datalayer_attr.content_type;
    content_variant = datalayer_attr.content_variant;
    get_datalayer = dataLayer.find(function(obj){return obj.event==="data_ready"});
    datalayer = {
      event: 'data_ready',
      page: {
        page_type: page_type,
        page_country: 'nl', // ISO 3166 is RECOMMENDED
        page_language: 'nl-nl', // ISO 3166 is RECOMMENDED
      },
      content_group: content_group,
      content_type: content_type,
      content_variant: content_variant,
      technology: {
        platform: 'web',
        ip_address: get_datalayer.technology.ip_address, // Used for IP filtering only
      },
    };
    // Create and push the datalayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ page: null }); // Clear the previous objects.
    window.dataLayer.push(datalayer);
  }
}

